/*!
 *  (c)(r) 2008-2021 IT-Service Robert Frunzke
 */

import { mj } from './page-mj.js';
import { postToBackend } from './fetch-util.js';


function setInSession( name_or_map, value ) {
	if( arguments.length===1 && typeof name_or_map==='object' ) {
		for( var k in name_or_map ) {
			if( name_or_map.hasOwnProperty(k) ) mj.session[k] = name_or_map[k];
		}
		if( mj.session_is_valid ) {
			postToBackend('json/session/-set',{'values':name_or_map},function(r) {});
		}
	} else {
		mj.session[name_or_map] = value;
		if( mj.session_is_valid ) {
			postToBackend('json/session/-set','name='+encodeURIComponent(name_or_map)+'&value='+encodeURIComponent(value),function(r) {});
		}
	}
}

function getFromSession( name, default_value ) {
	return mj.session && mj.session.hasOwnProperty(name) ? mj.session[name] : default_value;
}


export {
	setInSession,
	getFromSession
};
